import React, {Fragment, useRef, useState} from 'react';



export default function AddressText(props){
  if(props.entity==undefined){return null;}
  let country=undefined;
  if(props.countries!=undefined && props.entity.country_id!=null && props.entity.country_id!=undefined){
    for(let c of props.countries){if(c.id==props.entity.country_id){country=c;}}
  }
  return(<span>{((props.entity.address==undefined || props.entity.address==null)?"":props.entity.address+", ")+((props.entity.city==null || props.entity.city==undefined)?'':props.entity.city)+""+((props.entity.region==null || props.entity.region==undefined)?"":props.entity.region)+((props.entity.postal_code==undefined || props.entity.postal_code=='')?"":" ("+props.entity.postal_code+")")+((country==undefined)?"":" "+country.name)}</span>)
}
